import React from "react"
import { Box } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { REPORTED_ROUTE_COLOR } from "@/utils/routeHelper"

// Route-status pill shared by the drill-down rows and the summary option cards.
export const STATUS_BADGE_VARIANTS = {
  active: { bg: "#d6efd9", fg: "#2d7d32" },
  planned: { bg: "rgba(46,125,50,0.10)", fg: "#2e7d32" },
  suggested: { bg: "rgba(123, 31, 162, 0.10)", fg: "#7b1fa2" },
  archived: { bg: "#e4e7eb", fg: "#6b7480" },
  recent: { bg: "#e0f1ff", fg: "#1e6cb3" },
  unsaved: { bg: "rgba(245, 158, 11, 0.15)", fg: "#b7791f" },
  reported: { bg: alpha(REPORTED_ROUTE_COLOR, 0.08), fg: REPORTED_ROUTE_COLOR },
}

export default function StatusBadge({ variant = "planned", label }) {
  const v = STATUS_BADGE_VARIANTS[variant] ?? STATUS_BADGE_VARIANTS.planned
  return (
    <Box
      component="span"
      sx={{
        flexShrink: 0,
        fontSize: "9px",
        fontWeight: 700,
        letterSpacing: "0.3px",
        textTransform: "uppercase",
        px: 0.75,
        py: "2px",
        borderRadius: "8px",
        backgroundColor: v.bg,
        color: v.fg,
        lineHeight: 1.4,
      }}
    >
      {label}
    </Box>
  )
}
